import { Injectable, inject } from '@angular/core';
import Pusher from 'pusher-js';
import { Observable, share } from 'rxjs';
import { Transport } from 'pusher-js/types/src/core/config';
import { AuthenticationService } from 'app/core/auth/services/authentication.service';
import { EnvService } from 'environments/env.service';

export interface PusherConfigInterface {
  id: string;
  forceTLS: boolean;
  cluster: string;
  debug?: boolean;
}

export interface SoketiConfigInterface {
  id: string;
  wsHost: string;
  wsPort?: number;
  wssPort?: number;
  forceTLS?: boolean;
  disableStats?: boolean;
  /** Es: ['ws', 'wss'] */
  enabledTransports?: string[] | Transport[];
  cluster?: string;
  /** Endpoint per autorizzare i canali privati (es. /api/broadcasting/auth) */
  authEndpoint?: string;
  /** Header aggiuntivi da inviare alla authEndpoint (oltre ad Authorization) */
  authHeaders?: Record<string, string>;
}
export interface PusherMessage<T = any> {
  event: string;
  data: T;
}

@Injectable({ providedIn: 'root' })
export class PusherService {
  private readonly _authenticationService = inject(AuthenticationService);
  private readonly _envService = inject(EnvService);

  soketiStream(soketiConfig: SoketiConfigInterface, channel: string, events: string[]): Observable<PusherMessage> {
    return new Observable<PusherMessage>((subscriber) => {
      const cluster = soketiConfig.cluster ?? 'mt1';
      const options: any = {
        wsHost: soketiConfig.wsHost,
        wsPort: soketiConfig.wsPort ?? 443,
        wssPort: soketiConfig.wssPort ?? 443,
        forceTLS: soketiConfig.forceTLS ?? true,
        disableStats: soketiConfig.disableStats ?? true,
        enabledTransports: (soketiConfig.enabledTransports ?? ['ws', 'wss']) as Transport[],
        cluster,
      };

      if (soketiConfig.authEndpoint) {
        const token = this._authenticationService.jwt$()?.token ?? '';
        // const authEndpoint = this._envService.baseurl() + soketiConfig.authEndpoint;
        const authEndpoint = this._envService.getProxiedUrl(soketiConfig.authEndpoint);
        // console.log('authEndpoint', authEndpoint);
        options.channelAuthorization = {
          transport: 'ajax',
          endpoint: authEndpoint,
          headers: {
            Authorization: `Bearer ${token}`,
            ...soketiConfig.authHeaders,
          },
        };
      }

      const pusher = new Pusher(soketiConfig.id, options);
      const ch = pusher.subscribe(channel);
      events.forEach((event) => {
        ch.bind(event, (data: any) => subscriber.next({ event, data }));
      });

      return () => pusher.disconnect();
    }).pipe(share({ resetOnRefCountZero: true }));
  }
}
